<template>
    <v-layout d-block>
        <v-layout xs8 md12 class="title-block">
            <v-flex>
                <h1>Сравните предложения и оформите полис ОСАГО онлайн за 5 минут по лучшей цене.</h1>
            </v-flex>
            <v-flex xs4 py-2 class="hidden-sm-and-up">
                <img style="width: 134px; margin: -10px -40px 0px 0px;"
                     src="https://static.tildacdn.com/tild3230-3931-4162-b139-366636616232/960x640_2.gif"
                >
            </v-flex>
        </v-layout>
        <info-carousel
            :items="slider"
        />
        <v-layout class="get-cost"
                  style="max-width: 1240px"
        >
            <h3>Введите гос. номер и мы заполним данные по автомобилю за вас</h3>
            <v-form ref="form" v-on:submit.prevent="getByNumber">
                <v-flex>
                    <v-flex d-flex class="field-block gos-number-block">
                        <span class="alert-russian-symbols" v-if="!symbolsRussian">Могут использоваться только русские буквы</span>
                        <v-text-field
                            :label="placeholder"
                            v-model="gosNumber"
                            :rules="[rules.required, rules.number, rules.minCount]"
                            validate-on-blur
                            required
                            v-mask="'G QQQ GG QQQ'"
                            @focus="onFocusTextField"
                            @blur="onBlurTextField"
                            @input="onInputGosNumber"
                            ref="gosNumberInput"
                            class="field-upper-text"
                        />
                        <v-btn
                            class="button next-button block"
                            @click="getByNumber"
                        >
                            Узнать Стоимость
                        </v-btn>
                    </v-flex>
                    <div class="count-without-number">
                        <a
                            @click="countWithoutGosNumber"
                            :loading="this.wait"
                        >
                            Рассчитать без номера
                        </a>
                    </div>
                </v-flex>
            </v-form>
        </v-layout>
        <osago-partners v-if="showPartners"/>
    </v-layout>
</template>
<script>
import ymMixin from '../../mixins/ym';

export default {
    props: ['showPartners'],
    mixins: [ymMixin],
    name: "StepZero",
    data: () => ({
        gosNumber: null,
        preloading: false,
        wait: false,
        placeholder: 'Введите гос. номер',
        placeholderDefault: 'Введите гос. номер',
        symbolsRussian: true,
        lengthGosNumber: 0,
        flag: 0,
        numberMask: '_ ___ __ ___',
        slider: [
            {
                text: 'Наши посетители экономят на ОСАГО до 3500 р.',
                img: '/svg/grimacing-face.svg'
            },
            {
                text: 'Покупка полиса занимает всего 5 минут',
                img: '/png/rocket.png'
            },
            {
                text: 'Сами выберите лучшее предложение из 15 страховых компаний',
                img: '/svg/alarm-clock.svg'
            },
        ],
        rules: {
            required: v => !!v || 'Обязательное поле',
            number: v => /^[АВЕКМНОРСТУХ_\d\s]{4,}$/.test(v) || 'Неверный формат',
            minCount: v => (v && v.replace(/(?!-)[^0-9А-Я]/g, "").length >= 8) || 'Введите номер автомобиля',
        },
    }),

    methods: {

        onInputGosNumber(value) {
            let string = value.replace(/(?!-)[^a-zA-Z0-9а-яА-Я]/g, "")

            if (this.flag == 0) {
                this.flag = 1
                if (/[a-zA-Z]/.test(string)) {
                    this.symbolsRussian = false
                } else {
                    this.symbolsRussian = true
                }
            } else {
                this.flag = 0
            }
            if (string == '' || value.slice(-1) == ' ') {
                this.flag = 0
            }
            this.gosNumber = this.gosNumber.toUpperCase()
        },

        getByNumber() {
            if (!this.$refs.form.validate()) {
                return
            }
            this.gosNumber = this.gosNumber.replace(/(?!-)[^0-9А-Я]/g, "")
            this.reachGoal('input_gosnumber')
            this.toLoad()
        },

        toLoad() {
            this.$emit('startPreloading')
            this.$emit('requestsByNumber', this.gosNumber)
            this.$emit('next')
        },

        countWithoutGosNumber() {
            this.$emit('setNoLicensePlate')
            this.$emit('next')
        },

        changePreloading() {
            this.preloading = !this.preloading
            this.$emit('changePreloading', this.preloading)
        },

        delay(ms) {
            return new Promise((resolve, reject) => {
                setTimeout(resolve, ms);
            });
        },

        onFocusTextField() {
            this.placeholder = 'А 123 АА 777'
        },

        onBlurTextField() {
            if (!this.gosNumber) {
                this.placeholder = this.placeholderDefault
            } else {
                this.placeholder = null
            }
        }

    },
}
</script>
<style scoped>
.gos-number-block {
    position: relative;
}

.alert-russian-symbols {
    position: absolute;
    top: -5px;
    color: #ff5252;
    font-size: 14px;
}

.button {
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 18px !important;
    text-transform: none !important;
    box-shadow: none !important;

    width: 250px;
    height: 60px;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    padding: 0 !important;
    margin: 10px 20px 0 0;

    border-width: 1px;
    border-radius: 100px;
    border-style: solid;
}

.button >>> .v-btn__content {
    white-space: normal;
    padding: 0 110px;
    line-height: 1.1;
}

.next-button {
    color: #ffffff !important;
    background-color: #00ba57 !important;
    border-color: transparent;
}

</style>
<style>
.step-0 {
    font-family: 'SFUIDisplay';
}

.step-0 h1, h2 {
    font-size: 50px;
    text-align: center;
    font-family: 'SFUIDisplay';
}

.title-block {
    padding: 90px 0 50px;
    font-family: 'SFUIDisplay';
}

.get-cost {
    padding: 44px;
    background-color: #F1F2F2;
    border-radius: 25px;
    display: block;
    margin-bottom: 126px;
}

.get-cost h3 {
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    width: 360px;
    max-width: 100%;
    margin: 0 auto;
    margin-bottom: 20px;
}

.get-cost .field-block {
    padding: 20px 0;
    width: fit-content;
    margin: 0 auto;

}

.get-cost .field-block .v-text-field {
    padding: 0;
    margin-right: 21px;
}

.get-cost .field-block .v-input input {
    background-color: #fff;
}

.get-cost .field-block .button {
    margin: 0;
}

.get-cost .field-block .button .v-btn__content {
    padding: 0;
    width: 100%;
}

.get-cost .count-without-number {
    text-align: center;
}

.get-cost .count-without-number a {
    text-decoration: underline;
}

.our-partners {
    margin-top: 100px;
}

.our-partners h3 {
    font-size: 45px;
}

.field-upper-text input {
    text-transform: uppercase;
}


@media screen and (max-width: 600px) {
    .step-0 h1, h2 {
        font-size: 26px;
        text-align: left;
        font-weight: bold;
    }

    .step-0 .title-block {
        padding: 35px 15px 30px;
        overflow: hidden;
    }

    .get-cost {
        border-radius: 0;
        padding: 30px 15px;
        margin-bottom: 0;
    }

    .get-cost h3 {
        font-weight: bold;
        text-align: left;
    }

    .get-cost .field-block {
        padding: 17px 0 30px;
        flex-direction: column;
        width: 100%;
    }

    .get-cost .field-block .v-text-field {
        margin-right: 0;
    }

    .get-cost .field-block .button {
        width: 100%;
    }

    .get-cost .count-without-number {
        text-align: left;
    }

    .v-responsive .v-image .v-carousel__item {
        height: 60px !important;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/steps/StepZero.vue